"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyActionStartMailInbound = void 0;
const base_1 = require("./base");
const enums_1 = require("../../enums");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
exports.JourneyActionStartMailInbound = (0, base_1.journeyAction)({
    action: enums_1.JourneyActionEnum.StartMailInbound,
    channels: [enums_1.ChannelEnum.Mail,],
    direction: enums_1.JourneyNodeDirectionEnum.Output,
    getPorts: (node) => {
        return {
            [constants_1.JOURNEY_ACTION_START_MAIL_INBOUND_OUTPUT]: (0, utils_1.journeyNodePortAddDefault)({
                id: constants_1.JOURNEY_ACTION_START_MAIL_INBOUND_OUTPUT,
                type: enums_1.JourneyPortDirectionEnum.Output,
                removable: false,
                required: true,
                index: 0,
                title: 'CREATED',
                color: null,
            }),
        };
    },
});
